// @flow
import * as React from 'react';
import Geosuggest from 'react-geosuggest';
import type { CenterType, MapFilterProps } from '../types';
import './index.scss';

const MapFilter = (props: MapFilterProps) => {
  const handleChange = gmapObj => {
    if (gmapObj?.location) props.onVenueSelected(gmapObj.location);
    else if (!gmapObj) props.onVenueSelected(null);
  };

  return (
    <div className="map-search">
      <Geosuggest
        placeholder={props.placeholder}
        autoActivateFirstSuggest
        onSuggestSelect={handleChange}
        types={['(regions)']}
      />
    </div>
  );
};

export default React.memo<MapFilterProps>(MapFilter);
